import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/yelp': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M136.9 328C135.9 328.3 27.7 363.7 21.1 363.7 5.9 362.8 2.6 347.5 1.2 332.5-0.3 318.3-0.2 302.7 1.5 285.7 3.4 266.9 7 240.6 25.7 241.7 30.5 241.7 92.8 267.6 138.4 286.1 155.5 292.9 157 321.9 136.9 328zM194.8 214.1C196.6 252.3 169.3 262.6 147.6 228.4L41.3 60.4C39.8 53.8 41.6 48 46.6 43 62.2 26.5 146 3.2 168.1 8.9 175.6 10.8 180.2 15 181.9 21.5 183.2 29.8 193.4 188.9 194.8 214.1zM193.4 378.9C193.4 383.5 193.6 495.3 191.7 500.4 189.4 506.4 184.7 510.1 177.4 511.6 167.3 513.3 150.3 509.7 126.4 500.9 104.4 492.8 69.7 479.4 77.1 458.4 79.9 451.5 128.5 395.6 154.4 364.8 166.4 349.6 194.2 359.3 193.4 378.9zM373.6 261.1C368 264.8 262.8 289.3 255.5 291.7L255.8 291.1C237.7 295.8 220.4 272.6 232.5 256.5 236.2 252.8 298.4 164.1 305.3 159.5 310.5 155.9 316.6 155.7 323.6 158.9 342 167.7 378.7 222 381 243.5 380.9 246.4 382.2 255.2 373.6 261.1zM383.7 391.8C381 412.4 339.2 465.2 319.9 472.8 313 475.4 307 474.8 302.2 470.8 297.2 467.3 240.4 373.7 237.3 368.5 226.4 352.3 244.1 328.7 262.9 335.3 262.9 335.3 373.4 371 377.6 374.7 382.8 378.8 384.8 384.5 383.7 391.8z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/yelp.js
// module id = FiYc
// module chunks = 144